const isValidUrl = (string) => {
  const urlPattern = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  return urlPattern.test(string);
};

// Parsed, not pattern-matched, so `https://example.com:abc` or `https://#` are refused. The `//` is
// required: `https:merx.com` parses as merx.com, but a link to it opens a page of the current site.
// Whitespace is refused too: the browser would encode it, but the tender API reads sub-platform hosts
// with Java's URI.create, which rejects it, and those hosts are how tenders get matched to sub-platforms.
const isWebUrl = (value) => {
  if (typeof value !== 'string' || /\s/.test(value) || !/^https?:\/\//i.test(value)) return false;
  try {
    return !!new URL(value).hostname;
  } catch (error) {
    return false;
  }
};

// The site part of a url, as people name it: `https://www.seao.ca/accueil` → `seao.ca`.
const hostOf = (url) => {
  try {
    return new URL(url).host.replace(/^www\./, '');
  } catch (error) {
    return url;
  }
};

export { hostOf, isValidUrl, isWebUrl };
